@if (store.asArray(); as communes) {
  <p-table
    #communeTable
    [globalFilterFields]="['name']"
    [paginator]="communes.length > 10"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50]"
    [loading]="loading"
    [value]="communes">
    <ng-template pTemplate="caption">
      <app-table-list-caption
        [searchWord]="searchWord"
        (clearTable)="clear(communeTable)"
        (search)="
          communeTable.filterGlobal($event, 'contains')
        "></app-table-list-caption>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th>Name</th>
        <th>Aktionen</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-commune>
      <tr>
        <td>
          <i
            [class]="
              'fas fa-' + (commune.locked ? 'lock' : 'check-circle')
            "></i>
        </td>
        <td>
          <span class="flex align-items-center gap-3"
            ><i class="fas fa-city"></i> {{ commune.name }}</span
          >
        </td>

        <td>
          <a
            pButton
            class="p-button-rounded p-button-xs p-button-primary mr-2"
            icon="fas fa-link"
            (click)="copyCommuneLink(commune.slug || commune._id)"></a>
          <a
            pButton
            class="p-button-rounded p-button-xs p-button-primary mr-2"
            icon="fas fa-user-plus"
            [routerLink]="[
              { outlets: { bearbeiten: [commune._id, 'user', 'neu'] } },
            ]"></a>

          <app-table-list-actions
            [item]="commune"
            (confirm)="confirm($event, commune, commune.name)">
          </app-table-list-actions>

          <button
            pButton
            [rounded]="true"
            class="p-button-xs ml-2"
            icon="fas fa-users"
            (click)="setActiveCommune(commune._id)"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
} @else {
  <div role="alert" class="p-message p-message-info">
    <div class="p-message-wrapper">
      <span class="p-message-summary">404</span>
      <span class="p-message-detail">Keine Kommunen gefunden</span>
    </div>
  </div>
}

<p-sidebar
  [dismissible]="false"
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-7'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>

<p-sidebar
  (onHide)="onCommuneUsersClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-7'"
  [visible]="!!activeCommune">
  <ng-template pTemplate="header">
    <app-header icon="fas fa-users" text="Nutzer:innen"></app-header
  ></ng-template>

  <ng-container *ngIf="activeCommune">
    <app-user-list
      [communeId]="activeCommune"
      [addRoute]="[
        { outlets: { bearbeiten: [activeCommune, 'user', 'neu'] } },
      ]" />
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay"></app-mask>
